@if (visibleActions$ | async; as visibleActions) {
  <div *ngIf="visibleActions.length" class="flex gap-4">
    <pr-appointment-card-action
      *ngFor="let action of visibleActions; trackBy: trackByAction"
      [action]="action"
      [appointment]="appointment$ | async"
      [patient]="patient$ | async"
      (updateEventable)="updateEventable.emit($event)"
    />
  </div>
}
